import {
  Button,
  Card,
  Descriptions,
  Flex,
  Grid,
  Table,
  Typography,
} from "antd";
import pallete from "../../../utils/pallete";
import VerificationHistoryTable from "./VerificationHistoryTable";

export default function FacilitySection({
  legalityData,
  facilityData,
  facilityVerification,
  isVerifying,
  isRevising,
  isRejecting,
  isAllowedAction,
  onVerify,
  onRevise,
  onPreview,
  onDownload,
}) {
  const breakpoint = Grid.useBreakpoint();

  // Verification needs a monitoring that no earlier verification used yet.
  const hasPendingMonitoring = (facilityData?.monitorings || []).some(
    (e) => !e.verification,
  );


  const labelStyle = {
    width: breakpoint.lg ? 260 : "100%",
    minWidth: 260,
  };

  const contentStyle = {
    width: breakpoint.lg ? "calc(100% - 260px)" : "100%",
  };

  const descriptionTitle = (title) => (
    <Typography.Title
      level={3}
      style={{
        marginBottom: 0,
        fontWeight: "bold",
        fontSize: 18,
      }}
    >
      {title}
    </Typography.Title>
  );

  const descriptionSubtitle = (title) => (
    <Typography.Title
      level={3}
      style={{
        marginBottom: 0,
        fontWeight: "bold",
        fontSize: 14,
      }}
    >
      {title}
    </Typography.Title>
  );

  const statusTitle = (title) => (
    <Typography.Title
      level={3}
      style={{
        marginBottom: 0,
        fontWeight: "bold",
        fontSize: 20,
      }}
    >
      {title}
    </Typography.Title>
  );

  const renderDocument = (document, fallbackName) =>
    document?.filePath ? (
      <Flex align="center" gap={8}>
        <Typography.Text style={{ marginRight: "auto" }} ellipsis>
          {document.fileName}
        </Typography.Text>
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={() =>
            onDownload?.(document.filePath, document.fileName || fallbackName)
          }
        >
          Unduh
        </Button>
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={() => onPreview?.(document.filePath)}
        >
          Lihat
        </Button>
      </Flex>
    ) : (
      "-"
    );

  const dataInfrastrukturDanFasilitasItems = [
    {
      label: "Jumlah Ruang Pelatihan",
      span: 2,
      children: <Typography.Text>{facilityData?.trainingRoomQuantiy || "-"}</Typography.Text>,
    },
    {
      label: "Ketersediaan Asrama Untuk Peserta",
      span: 2,
      children: <Typography.Text>{facilityData?.participantRoom == false ? "Tidak Tersedia" : "Tersedia"}</Typography.Text>,
    },
    ...(facilityData?.participantRoom == false
      ? []
      : [
          {
            label: "Dokumentasi Asrama",
            span: 2,
            children: renderDocument(
              facilityData?.attachments?.dormitoryDocumentation,
              "dokumentasi-asrama",
            ),
          },
        ]),
    {
      label: "Fasilitas Kesehatan",
      span: 2,
      children: <Typography.Text>{facilityData?.healthFacility == false ? "Tidak Tersedia" : "Tersedia"}</Typography.Text>,
    },
    {
      label: "Dokumentasi Sarana & Prasarana Lembaga",
      span: 2,
      children: renderDocument(
        facilityData?.attachments?.facilitiesInfrastructureDocumentation,
        "dokumentasi-sarana-prasarana",
      ),
    },
  ];

  const dataJumlahAlatPraktekDimilikiItems =
    facilityData?.practicalTools?.length > 0
      ? facilityData.practicalTools.map((tool, index) => [
        {
          label: `Nama Alat ${index + 1}`,
          children: <Typography.Text>{tool?.name || "-"}</Typography.Text>,
        },
        {
          label: "Jumlah",
          children: <Typography.Text>{tool?.quantity ?? "-"}</Typography.Text>,
        },
      ]).flat()
      : [
        {
          label: "Nama Alat",
          children: <Typography.Text>-</Typography.Text>,
        },
        {
          label: "Jumlah",
          children: <Typography.Text>-</Typography.Text>,
        },
      ];

  const dataDokumentasiAlatPraktikItem = {
    label: "Dokumentasi Alat Praktik",
    span: 2,
    children: renderDocument(
      facilityData?.attachments?.practicalToolsDocumentation,
      "dokumentasi-alat-praktik",
    ),
  };

  const dataFasilitasPenunjangItems =
    facilityData?.supportingFacilities?.length > 0
      ? facilityData.supportingFacilities.map((fac, index) => ({
        label: `Fasilitas ${index + 1}`,
        span: 2,
        children: <Typography.Text>{fac?.name || "-"}</Typography.Text>,
      }))
      : [
        {
          label: "Nama Fasilitas",
          span: 2,
          children: <Typography.Text>-</Typography.Text>,
        },
      ];

  const dataFasilitasLainItems =
    facilityData?.otherFacilities?.length > 0
      ? facilityData.otherFacilities.map((fac, index) => ({
        label: `Fasilitas ${index + 1}`,
        span: 2,
        children: <Typography.Text>{fac?.name || "-"}</Typography.Text>,
      }))
      : [
        {
          label: "Fasilitas Lain",
          span: 2,
          children: <Typography.Text>-</Typography.Text>,
        },
      ];

  const instructorStatusLabel = {
    permanent: "Instruktur Tetap",
    temporary: "Instruktur Tidak Tetap",
  };

  const instructorColumns = [
    {
      title: "No",
      width: 60,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Nama Lengkap",
      dataIndex: "fullName",
    },
    {
      title: "Status",
      dataIndex: "employmentStatus",
      width: 200,
      render: (val) => instructorStatusLabel[val] || "-",
    },
    {
      title: "Sertifikat Kompetensi Instruktur",
      dataIndex: "competencyCertificate",
      width: 360,
      render: (certificate) =>
        certificate?.filePath ? (
          <Flex align="center" gap={8}>
            <Typography.Text style={{ marginRight: "auto" }} ellipsis>
              {certificate.fileName}
            </Typography.Text>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() =>
                onDownload?.(
                  certificate.filePath,
                  certificate.fileName || "sertifikat-instruktur",
                )
              }
            >
              Unduh
            </Button>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => onPreview?.(certificate.filePath)}
            >
              Lihat
            </Button>
          </Flex>
        ) : (
          "-"
        ),
    },
  ];

  const dataInstrukturItems = [
    {
      label: "Jumlah Instruktur Tetap",
      children: (
        <Typography.Text>
          {facilityData?.permanentInstructorQuantity || "-"}
        </Typography.Text>
      ),
    },
    {
      label: "Jumlah Instruktur Tidak Tetap",
      children: (
        <Typography.Text>
          {facilityData?.temporaryInstructorQuantity || "-"}
        </Typography.Text>
      ),
    },
  ];

  const dataKualifikasiInfrastrukturKompetensisSertifikasiItems = [
    {
      label: "Jumlah Instruktur Tetap",
      children: (
        <Typography.Text>
          {facilityData?.competencyCertificationPermanentInstructor || "-"}
        </Typography.Text>
      ),
    },
    {
      label: "Jumlah Instruktur Tidak Tetap",
      children: (
        <Typography.Text>
          {facilityData?.competencyCertificationTemporaryInstructor || "-"}
        </Typography.Text>
      ),
    },
    {
      label: "Jumlah Tenaga Administrasi",
      children: (
        <Typography.Text>
          {facilityData?.administrativeStaffQuantity || "-"}
        </Typography.Text>
      ),
    },
    {
      label: "Jumlah Tenaga Pendukung Lainnya",
      children: (
        <Typography.Text>
          {facilityData?.otherSupportStaffQuantity || "-"}
        </Typography.Text>
      ),
    },
  ];

  const dataKerjaSamaMitraItems = [
    {
      label: "Mitra Kerja Sama dengan Industri",
      span: 2,
      children: (
        <Typography.Text>
          {facilityData?.industryPartner || "-"}
        </Typography.Text>
      ),
    },
    {
      label: "Mitra Lembaga Pendidikan Lain",
      span: 2,
      children: (
        <Typography.Text>
          {facilityData?.educationalPartner || "-"}
        </Typography.Text>
      ),
    },
    {
      label: "Kemitraan dengan Pemerintah",
      span: 2,
      children: (
        <Typography.Text>
          {facilityData?.govermentPartner || "-"}
        </Typography.Text>
      ),
    },
    {
      label: "Kerjasama dengan LSP/Lembaga Sertifikasi",
      span: 2,
      children: (
        <Typography.Text>{facilityData?.lspPartner || "-"}</Typography.Text>
      ),
    },
  ];

  const dataJumlahPesertaTelahDilatihItems =
    facilityData?.participantsTrainedQuantity
      ?.map((data, index) => [
        {
          label: "Tahun",
          children: <Typography.Text>{data?.year || "-"}</Typography.Text>,
        },
        {
          label: "Jumlah",
          children: <Typography.Text>{data?.qty || "-"}</Typography.Text>,
        },
      ])
      .flat() || [];

  const dataTingkatKeberhasilanPesertaItems =
    facilityData?.participantsWorked
      ?.map((data, index) => [
        {
          label: "Tahun",
          children: <Typography.Text>{data?.year || "-"}</Typography.Text>,
        },
        {
          label: "Jumlah",
          children: <Typography.Text>{data?.qty || "-"}</Typography.Text>,
        },
      ])
      .flat() || [];

  const dataEvaluasiPengembanganLembagaItems = [
    {
      label: "Program Pengembangan Lembaga dalam 3-5 Tahun Mendatang",
      span: 2,
      children: (
        <Typography.Text>
          {facilityData?.institutionalDevProgram35y || "-"}
        </Typography.Text>
      ),
    },
    {
      label: "Evaluasi Kualitas Pelatihan yang Dilakukan",
      span: 2,
      children: (
        <Typography.Text>
          {facilityData?.trainingEvaluation || "-"}
        </Typography.Text>
      ),
    },
    {
      label:
        "Inovasi dan Perubahan dalam Program Pelatihan untuk Meningkatkan Daya Saing Peserta di Pasar Kerja Global",
      span: 2,
      children: (
        <Typography.Text>
          {facilityData?.trainingInnovationGlobal || "-"}
        </Typography.Text>
      ),
    },
    {
      label:
        "Rencana Pengembangan Infrastruktur dan Fasilitas untuk Meningkatkan Kualitas Pelatihan",
      span: 2,
      children: (
        <Typography.Text>
          {facilityData?.infraFacilityDevPlan || "-"}
        </Typography.Text>
      ),
    },
  ];

  return (
    <>
      <Descriptions
        style={{ marginBottom: 24 }}
        column={breakpoint.lg ? 2 : 1}
        bordered
        size="small"
        title={descriptionTitle("Infrastruktur dan Fasilitas")}
        layout={breakpoint.lg ? "horizontal" : "vertical"}
        items={dataInfrastrukturDanFasilitasItems}
      />

      <Descriptions
        style={{ marginBottom: 24 }}
        column={breakpoint.lg ? 2 : 1}
        bordered
        size="small"
        styles={{
          label: labelStyle,
          content: contentStyle,
        }}
        title={descriptionSubtitle("Jumlah Alat Praktek yang Dimiliki")}
        layout={breakpoint.lg ? "horizontal" : "vertical"}
        items={[
          ...dataJumlahAlatPraktekDimilikiItems,
          dataDokumentasiAlatPraktikItem,
        ]}
      />

      <Descriptions
        style={{ marginBottom: 24 }}
        column={breakpoint.lg ? 2 : 1}
        bordered
        size="small"
        styles={{
          label: labelStyle,
          content: contentStyle,
        }}
        title={descriptionSubtitle("Fasilitas Penunjang")}
        layout={breakpoint.lg ? "horizontal" : "vertical"}
        items={dataFasilitasPenunjangItems}
      />

      <Descriptions
        style={{ marginBottom: 24 }}
        column={breakpoint.lg ? 2 : 1}
        bordered
        size="small"
        styles={{
          label: labelStyle,
          content: contentStyle,
        }}
        title={descriptionSubtitle("Fasilitas Lain yang Mendukung Pelatihan")}
        layout={breakpoint.lg ? "horizontal" : "vertical"}
        items={dataFasilitasLainItems}
      />

      {descriptionTitle("Sumber Daya Manusia")}

      <Descriptions
        style={{ marginBottom: 24, marginTop: 20 }}
        column={breakpoint.lg ? 2 : 1}
        bordered
        size="small"
        styles={{
          label: labelStyle,
          content: contentStyle,
        }}
        title={descriptionSubtitle("Jumlah Instruktur/Pelatih")}
        layout={breakpoint.lg ? "horizontal" : "vertical"}
        items={dataInstrukturItems}
      />

      <Descriptions
        style={{ marginBottom: 24 }}
        column={breakpoint.lg ? 2 : 1}
        styles={{
          label: labelStyle,
          content: contentStyle,
        }}
        bordered
        size="small"
        title={descriptionSubtitle(
          "Kualifikasi Instruktur (Kompetensi & Sertifikasi)"
        )}
        layout={breakpoint.lg ? "horizontal" : "vertical"}
        items={dataKualifikasiInfrastrukturKompetensisSertifikasiItems}
      />

      <div style={{ marginBottom: 24 }}>
        {descriptionSubtitle("Informasi Detail Instruktur")}
        <Table
          style={{ marginTop: 12 }}
          size="small"
          bordered
          pagination={false}
          rowKey="uuid"
          columns={instructorColumns}
          dataSource={facilityData?.instructors || []}
          scroll={{ x: 700 }}
          locale={{ emptyText: "Belum ada data instruktur" }}
        />
      </div>

      <Descriptions
        style={{ marginBottom: 24 }}
        column={breakpoint.lg ? 2 : 1}
        bordered
        size="small"
        styles={{
          label: labelStyle,
          content: contentStyle,
        }}
        title={descriptionTitle("Kerja Sama dan Mitra")}
        layout={breakpoint.lg ? "horizontal" : "vertical"}
        items={dataKerjaSamaMitraItems}
      />

      {descriptionTitle("Peserta Pelatihan")}

      <Descriptions
        style={{ marginBottom: 24, marginTop: 20 }}
        column={breakpoint.lg ? 2 : 1}
        bordered
        size="small"
        styles={{
          label: labelStyle,
          content: contentStyle,
        }}
        title={descriptionSubtitle("Jumlah Peserta yang Telah Dilatih")}
        layout={breakpoint.lg ? "horizontal" : "vertical"}
        items={dataJumlahPesertaTelahDilatihItems}
      />

      <Descriptions
        style={{ marginBottom: 24 }}
        column={breakpoint.lg ? 2 : 1}
        bordered
        size="small"
        styles={{
          label: labelStyle,
          content: contentStyle,
        }}
        title={descriptionSubtitle(
          "Tingkat Keberhasilan Peserta dalam Menemukan Pekerjaan"
        )}
        layout={breakpoint.lg ? "horizontal" : "vertical"}
        items={dataTingkatKeberhasilanPesertaItems}
      />

      <Descriptions
        style={{ marginBottom: 24 }}
        column={breakpoint.lg ? 2 : 1}
        bordered
        size="small"
        styles={{
          label: labelStyle,
          content: contentStyle,
        }}
        title={descriptionTitle("Evaluasi dan Pengembangan Lembaga")}
        layout={breakpoint.lg ? "horizontal" : "vertical"}
        items={dataEvaluasiPengembanganLembagaItems}
      />

      <div style={{ marginBottom: 24, paddingTop: 24 }}>
        <Card title={statusTitle("Status Verifikasi")}>
          <VerificationHistoryTable
            history={facilityData?.verificationStatusses || []}
          />
        </Card>
      </div>

      {facilityVerification?.status !== "accepted" && isAllowedAction && (
        <Flex justify="flex-end" align="center" gap={12} wrap="wrap">
          {!hasPendingMonitoring && (
            <Typography.Text type="danger" style={{ marginRight: "auto" }}>
              * Isi bukti monitoring terlebih dahulu sebelum memverifikasi data
              fasilitas.
            </Typography.Text>
          )}
          <Button
            type="primary"
            loading={isVerifying}
            disabled={isRevising || isRejecting || !hasPendingMonitoring}
            style={{
              backgroundColor: pallete.success.variant,
              fontWeight: 600,
            }}
            onClick={onVerify}
          >
            Terima
          </Button>

          <Button
            loading={isRevising}
            disabled={isRevising || !hasPendingMonitoring}
            style={{
              backgroundColor: pallete.indigo.main,
              color: "white",
              fontWeight: 600,
              border: "none",
            }}
            onClick={onRevise}
          >
            Revisi
          </Button>
        </Flex>
      )}
    </>
  );
}
